import { ImageOff } from "lucide-react";
import { usePhotoUrl } from "@/hooks/use-assets";
import { cn } from "@/lib/utils";

export const AssetThumb = ({ photoId, icon: Icon = ImageOff, className = "" }) => {
  const url = usePhotoUrl(photoId);
  return (
    <div className={cn("flex items-center justify-center overflow-hidden rounded-xl bg-secondary", className)}>
      {url ? <img src={url} alt="" className="h-full w-full object-cover" /> : <Icon className="h-5 w-5 text-muted-foreground" />}
    </div>
  );
};
